<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-7">
<p class="centerImage"><img alt="image" src="images/img14.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">Peter de Heynoe, Lord of Stenbury, takes aim with his strongbow. </em><span class="smallcaps">The author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14_ch17.vue?08047b26